<template>
  <!--
      	作者：zhuchangtao
      	时间：2021-03-30
      	描述：题库-任务列表
      -->
  <div>
     <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
       <el-form-item label="名称/手机号" v-if="task.type ==1 ||task.type ==2 ||task.type ==4 "><el-input size="small" v-model="searchForm.search" placeholder="请输入名称/手机号"></el-input></el-form-item>

       <el-form-item label="类型" v-if="task.type ==3">
         <el-select size="small" v-model="searchForm.unit_id" placeholder="请选择">
           <el-option label="全部" value=""></el-option>
           <el-option v-for="(item, index) in unitList" :key="index" :label="item.unit_name" :value="item.unit_id"></el-option>


         </el-select>
       </el-form-item>

       <el-form-item label="起始时间">
         <div class="block">
           <span class="demonstration"></span>
           <el-date-picker
             size="small"
             v-model="searchForm.create_time"
             type="daterange"
             value-format="yyyy-MM-dd"
             range-separator="至"
             start-placeholder="开始日期"
             end-placeholder="结束日期"
           ></el-date-picker>
         </div>
       </el-form-item>
       <el-form-item><el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>

     </el-form>
    <div class="common-level-rail"><el-button size="small" type="primary" icon="el-icon-plus" @click="addtask" v-if="task.type ==3" v-auth="'/task/clock/add'">添加打卡</el-button></div>
    <div class="table-wrap">
      <el-table :data="tableData" style="width: 100%" border v-loading="loading">
        <el-table-column prop="task_clock_id" label="打卡ID" width="60"></el-table-column>
        <el-table-column prop="user" label="用户信息" v-if="task.type == 2|| task.type ==1|| task.type ==4">
          <template slot-scope="scope">
            <div class="text-ellipsis" :title="scope.row.user">姓名：{{scope.row.user.real_name}}<span v-if="scope.row.user.is_team">(队长)</span></div>
            <div class="text-ellipsis" :title="scope.row.user">联系方式{{scope.row.user.mobile}}</div>
          </template>
        </el-table-column>
         <el-table-column prop="unit.unit_name" label="单位团队" v-if="task.type ==4" >
           <template slot-scope="scope">
            <div class="text-ellipsis" >{{scope.row.unit.unit_name}}</div>
            <div class="text-ellipsis" >{{scope.row.group.unit_group_name}}</div>
          </template>
         </el-table-column>
        <!-- <el-table-column prop="task_title" label="打卡标题" v-if="task.type == 2">
          <template slot-scope="scope">
            <div class="text-ellipsis" :title="scope.row.task_title">{{scope.row.task_title}}</div>
          </template>
        </el-table-column> -->
        <el-table-column prop="task.task_name" label="任务标题" ></el-table-column>
        <el-table-column prop="task_type_text" label="任务类型" ></el-table-column>
        <el-table-column prop="image" label="封面图片" v-if='task.type ==4' >
          <template slot-scope="scope">
            <div class="product-info">
              <div class="pic" v-if="scope.row.image"><img v-img-url="scope.row.image.file_path" alt="" /></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="video" label="视频" v-if='task.type ==4' >
          <template slot-scope="scope">
            <div class="product-info">
              <div class="pic"  v-if="scope.row.video"><video :src="scope.row.video.file_path" width="100px" height="120px" controls="controls" /></div>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="like_count" label="点赞统计" v-if='task.type == 2|| task.type ==4' ></el-table-column>
        <el-table-column prop="comment_count" label="评论统计"  v-if='task.type == 2|| task.type ==4' ></el-table-column> -->
        <el-table-column prop="step_count" label="打卡步数"  v-if='task.type ==1' ></el-table-column>
        <el-table-column prop="total_step" label="累计步数"  v-if='task.type ==1' ></el-table-column>
        <el-table-column prop="task_number" label="次数"  v-if='task.type ==4' ></el-table-column>
        <el-table-column prop="create_time" label="打卡时间" ></el-table-column>

        <el-table-column prop="name" label="操作" v-if="task.type ==4">
          <template slot-scope="scope">
            <el-button @click="edittask(scope.row)" type="text" size="small" v-auth="'/task/clock/edit'">审核修改</el-button>
            <!-- <el-button @click="deletetask(scope.row)" type="text" size="small" v-auth="'/task/clock/delete'">删除</el-button> -->

          </template>
        </el-table-column>
      </el-table>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" @click="cancelFunc">返回</el-button>

    </div>
  </div>
</template>

<script>
import taskApi from '@/api/task.js';

export default {
  components: {

  },
  data() {
    return {
      task_id:'',
      /*横向表单数据模型*/
      searchForm: {
        search: "",
        unit_id:'',
        create_time: ''
      },
      /*表单数据*/
      tableData: [],
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      commentData: [],
      loading: true,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      task:'',
      unitList:[]
    };
  },
  created() {
    this.task_id = this.$route.query.task_id;
    /*获取任务列表*/
    this.getTableList();
  },
  methods: {
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.tableData = [];
      this.getTableList();
    },
    /*获取任务列表*/
    getTableList() {
      let self = this;
      let Params = this.searchForm;
      Params.page = self.curPage;
      Params.task_id = self.task_id;
      taskApi.clockList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
          self.task = data.data.task;
          self.unitList = data.data.unitList;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*添加任务*/
    addtask() {

      this.$router.push({
        path: '/task/clock/add',
        query: {
          task_id:this.task_id
        }
      });
    },

    /*编辑任务*/
    edittask(row) {
      let params = row.task_clock_id;
      this.$router.push({
        path: '/task/clock/edit',
        query: {
          task_clock_id: params,
          task_id:this.task_id
        }
      });
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.getTableList();
    },

    /*删除任务*/
    deletetask(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          taskApi.deleteClock(
            {
              task_clock_id: row.task_clock_id,
              task_id:self.task_id
            },
            true
          )
            .then(data => {
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.loading = false;
              self.getTableList();
            })
            .catch(error => {});
        })
        .catch(() => {});
    },
    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    }







  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/task/clock/index.vue